export default __webpack_public_path__ + "080583d236686b0d8f01a0e66dd5a43b.woff";